import { OfferPaymentType, OfferType } from "@1games-ru/region-shared/dist/enums/offer/offer";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { OfferMpProvider } from "@/core/data-provider/data-mp/offer/offer-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import {
  NotificationItemOffer,
  useNotificationStore,
} from "@/stores/notifications/notificationStore";
import toast from "@/domains/toasts/helpers/toast";

export default function useOfferHandlers() {
  const { t } = useTranslation("notifications");
  const { removeNotification } = useNotificationStore();

  const resolve = useCallback(
    async (
      id: string,
      accept: boolean,
      paymentType: OfferPaymentType = OfferPaymentType.NotProvided,
    ) => {
      try {
        const result = await OfferMpProvider.resolve(id, accept, paymentType);
        if (result instanceof RpcMpProviderFailedResponse) {
          toast.error(t("errors.RESOLVE_OFFER_ERROR"));
          return;
        }

        toast.success(t("offerSuccessResolve"));
      } catch (e) {
        console.error(e);
        toast.error(t("errors.RESOLVE_OFFER_ERROR_SYSTEM"));
      }
    },
    [t],
  );

  const acceptHandler = useCallback(
    (
      id: string,
      notification: NotificationItemOffer,
      paymentType: OfferPaymentType = OfferPaymentType.NotProvided,
    ) => {
      switch (notification.data.type) {
        case OfferType.BusinessInvite:
        case OfferType.BusinessTrade:
        case OfferType.VehicleTrade:
        case OfferType.EstateTrade:
        case OfferType.EstateInvite:
          OfferMpProvider.resolverShow({
            amount: notification.data.amount,
            baseCharacterId: notification.data.baseCharacterId,
            createdAt: notification.data.createdAt,
            destroyAt: notification.data.destroyAt,
            payload: notification.data.payload,
            quantity: notification.data.quantity,
            status: notification.data.status,
            targetCharacterId: notification.data.targetCharacterId,
            targetId: notification.data.targetId,
            type: notification.data.type,
            uuid: id,
          });

          break;
        default: {
          resolve(id, true, paymentType);
        }
      }
      removeNotification(id);
    },
    [removeNotification, resolve],
  );

  const declineHandler = useCallback(
    (uuid: string) => {
      resolve(uuid, false);
      removeNotification(uuid);
    },
    [removeNotification, resolve],
  );

  return { acceptHandler, declineHandler };
}
